"use client";
import { LandingSiteTemplateGetDataGalleryItemDataSourceOutputApiModel } from "@/Apis/ClinicApi";
import { SmartImage } from "@/Components";
import { useT } from "@/Hooks";
import { FC } from "react";

interface GalleryItemProps {
  model: LandingSiteTemplateGetDataGalleryItemDataSourceOutputApiModel;
}

const GalleryItem: FC<GalleryItemProps> = ({ model }) => {
  const t = useT();
  return (
    <div className="item">
      <div className="store-item">
        <div className="store-img">
          <SmartImage
            cover
            width={276}
            height={250}
            src={model.FileUrl}
            alt={
              model.Title ??
              t("landing.galleryItem.alt", undefined, "Center gallery")
            }
            className="img-fluid"
            objectFit="contain"
          />
        </div>
        <div className="store-content">
          <h4>
            {/* <SmartLink href={model.Link}> */}
            {model.Title}
            {/* </SmartLink> */}
          </h4>
          <p>{model.Description}</p>
        </div>
      </div>
    </div>
  );
};

export default GalleryItem;
